// extracted by mini-css-extract-plugin
module.exports = {"frame":"Frame_frame__14mnz","frameLine":"Frame_frameLine__3z8GX","network":"Frame_network__2fsb2"};